import styled from 'styled-components';

export const ContainerHeader = styled.div`
display: flex;
min-width: 636px;
max-width: 720px;
margin: 0 auto;
padding: 40px 16px;
height: 20px;    
justify-content: space-between;
align-items: center;
.text{
 color: var(--Primary-Orange-Prima, #ff4f00);
        text-align: center;
        max-width: 125px;
        font: 700 16px/125% Calibri, -apple-system, Roboto, Helvetica, sans-serif;
}
#btn-identity-back{
    display: flex;
    align-items: center;
    justify-content: center;
}

@media (max-width: 1023px) {
    min-width: 100%;
    width: 100%;
    margin: 0px;
    padding: 0px 32px;
    height: 64px;
    box-shadow: 2px 2px 10px 2px rgba(235, 235, 235, 1);
    align-items: center;
    display: none;
}

  @media (max-width: 461px) {
    min-width: 100%;
    width: 100%;
    margin: 0px;
    padding: 0px 16px;
    height: 64px;
    box-shadow: 2px 2px 10px 2px rgba(235, 235, 235, 1);
    align-items: center;
    display: none;
  }

`